export class TextInfo {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get text() {
        return this.parent;
    }
    get textIndex() {
        return this.text.aspect.local.traitsOf.text.indexOf(this.text.trait);
    }
    get textNumber() {
        return this.textIndex + 1;
    }
}
